import { createFileRoute } from '@tanstack/react-router';
import { AdminNotificationDetailRoute } from '@/pages/admin-notifications/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute(
  '/admin/_layout/notifications/_layout/$id'
)({
  component: AdminNotificationDetailRouteComponent,
});

function AdminNotificationDetailRouteComponent() {
  const { id } = Route.useParams();

  return <AdminNotificationDetailRoute id={id} />;
}
